<nx-toolbar>

  <button
    nxPlainButton=""
    type="button"
    aria-label="a useful label"
    class="back-right"
    (click)="cancelSupplier()"
    >
    <nx-icon name="arrow-left" class="nx-margin-right-2xs"></nx-icon>
    @if (!mobile) {
      {{'general.cancel' | caption}}
    }
  </button>

  @if (!mobile) {
    @for (option of modalOptions; track option) {
      <button
        nxIconButton="tertiary small"
        aria-label="a useful label"
        type="button"
        class="nx-margin-right-2xs nx-margin-bottom-0"
        [disabled]=option.disable
        (click)="option.openModalSupplier()"
        >
        <nx-icon name="{{option.iconName}}"></nx-icon>
      </button>
    }
    <button nxButton="primary small" type="button" (click)="saveSupplier()" [disabled]="disableSave">
      <nx-icon name="save-o" class="nx-margin-right-2xs"></nx-icon>
      {{'general.save' | caption}}
    </button>
  }

  @if (mobile) {
    <button
      nxIconButton="cte small"
      [nxContextMenuTriggerFor]="menu"
      aria-label="Open menu"
      type="button"
      >
      <nx-icon aria-hidden="true" name="ellipsis-h"></nx-icon>
    </button>
    <nx-context-menu #menu="nxContextMenu">
      @for (option of modalOptions; track option) {
        <button
          nxContextMenuItem
          aria-label="a useful label"
          type="button"
          class="nx-margin-right-2xs nx-margin-bottom-0"
          (click)="option.openModalSupplier()"
          >
          <nx-icon name="{{option.iconName}}"></nx-icon>
          {{option.name | caption}}
        </button>
      }
      <button nxContextMenuItem type="button" (click)="saveSupplier()" [disabled]="disableSave">
        <nx-icon name="save-o" class="nx-margin-right-2xs"></nx-icon>
        {{'general.save' | caption}}
      </button>
    </nx-context-menu>
  }
</nx-toolbar>
